module.exports = __webpack_public_path__ + "static/media/aj.adc23ee6.jpg";